import { createApp } from 'vue/dist/vue.esm-bundler'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'

import store from './store'

import en from './lang/en.json'
import nl from './lang/nl.json'
import ru from './lang/ru.json'

// import discountList from './lang/discounts.json'


const app = createApp(App)

const messages = {
  en,
  nl,
  ru
}
import { createI18n }  from 'vue-i18n';
export const i18n = new createI18n({
    locale: 'nl',
    messages: messages
});

app.use(i18n)

// register modal component
app.component("modal", {
  template: "#modal-template"
});


app.mixin({
  
  methods: {

    siteLinkout: function() {
      return "https://rica.nl";
    },

    renderDDLB(name, values, selected, firstval) {
      var ddlb = "<select id='"+name+"' name='"+name+"' class='default-input'>";
      ddlb += "<option value=''>" + firstval + "</option>";

      var sel = "";
      for (const [key, value] of Object.entries(values)) {
          if(selected == `${key}`) {
              sel = " selected";
          } else {
              sel = "";
          }
          ddlb += "<option value='" + `${key}` + "' "+sel+">" + `${value}` + "</option>";
      }
      ddlb += "</select>";
      return ddlb;
      },
      custom_fixUglyPrice(price) {
        // in cents/units!
          if(price == "" || price == undefined) {
              price = "0";
          }
          var priceInt = price.replace("+ VAT","");
           priceInt = priceInt.replace("+ BTW","");
        priceInt = priceInt.replace("€","");
          priceInt = priceInt.split(" ")[0];
        return priceInt;
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      extractDiscount(discount_string) {
        console.log("extractDiscount:" + discount_string)
        var discountValues = discount_string.split("EUR");
        var discountPrice = discountValues[0].substr(2,discountValues[0].length-3); 
        return discountPrice;
      },
      removeBR(value) {
        var priceInt = value.replace("<BR>"," ");
        var priceInt = value.replace("<br>"," ");
        return priceInt;
      }
  },
  computed: {
    


    discountsList() {
      // var dl = discountList;
      var dl = this.$store.state.discountList;
      // var dl = "sdsd";
      return dl;
    },
    shoppingCart() {
        // restructure products

        var cart = [];
        var curCart = this.$store.state.shoppingCart;
        for(var i=0 ; i < curCart.length ; i++) {
            var curProduct = curCart[i];
            var curProductID = curProduct["ProductID"];
            if(!cart[curProductID]) {
                cart[curProductID] = curProduct; 
                cart[curProductID]["amount"] = 0;

            } 
            cart[curProductID]["amount"] += 1;
        }
        var endCart = [];
        for (const [key, value] of Object.entries(cart)) {

             endCart.push(value);
        }
        return endCart;
    },
    chargeShipping() {
      var curCart = this.$store.state.shoppingCart;
      var chargeShipping = false;
      for(var i=0 ; i < curCart.length ; i++) {
        var curProduct = curCart[i];
        var curProductSubType = curProduct["ProductSubTypeID"];
        if(curProductSubType == "70") {
          chargeShipping = true;
        }
      }
      return chargeShipping;

    },
 
    hasSoftLoader() {
      var curVariants = this.$store.state.curTuningProducts;
      var hasSoftLoader = false;
      for(var i=0 ; i < curVariants.length ; i++) {
        var curProduct = curVariants[i];
        var curProductSubType = curProduct["ProductSubTypeID"];
        if(curProductSubType == "70") {
          hasSoftLoader = true;
        }
      }
      return hasSoftLoader;

    },
    discountTotal() {
        // get cart
        var discountTotal = 0;
        // var hasStagingProduct = false;
        // check if cart contains staging products (ProductSubTypeID 1-7)
        this.hasStagingProduct = false;
        for(var j=0 ; j < this.shoppingCart.length ; j++) {
            if(this.shoppingCart[j].ProductSubTypeID >= 1 && this.shoppingCart[j].ProductSubTypeID <= 7) {
                this.hasStagingProduct = true;
                // break;
            }
        }
        for(var i=0 ; i < this.shoppingCart.length ; i++) {

            var curPrice = this.custom_fixUglyPrice(this.shoppingCart[i].Price)*this.shoppingCart[i].amount;
            // // extract discounted price form DiscountDescription
            // if(this.shoppingCart[i].hasOwnProperty("DiscountDescription")) {
            //     var discountValues = this.shoppingCart[i].DiscountDescription.split("EUR");
            //     var discountPrice = discountValues[0].substr(2,discountValues[0].length-3); 
            //     var discountDescription = discountValues[1].substr(8,discountValues[1].length-9); 
            //     this.discountName = discountDescription;
            //     discountTotal += curPrice - (discountPrice*this.shoppingCart[i].amount);

            // } else
            // check if ProductCode is set (for promo code and discount purposes)
            if(this.shoppingCart[i].hasOwnProperty("ProductCode")) {
                // this.hasPromocode = true;
                var ProductCode = this.shoppingCart[i].ProductCode;
                // is 50% off eligable
                if(ProductCode == "50p" && this.hasStagingProduct) {
                  // discountTotal += (curPrice/2)  ;
                  //  this.discountName = "50% off";
                } else {
             
                }

                if(this.shoppingCart[i].hasOwnProperty("DiscountDescription")) {
                  var discountValues = this.shoppingCart[i].DiscountDescription.split("EUR");
                  var discountPrice = discountValues[0].substr(2,discountValues[0].length-3); 
                  var discountDescription = discountValues[1].substr(8,discountValues[1].length-9); 
                  // this.discountName = discountDescription;
                  if(ProductCode == "50p" && this.hasStagingProduct) {
                    // discountTotal += curPrice - ((discountPrice*this.shoppingCart[i].amount)/2);

                  } else {

                    discountTotal += curPrice - (discountPrice*this.shoppingCart[i].amount);
                  }
                } 

                if(ProductCode == "50p" && this.hasStagingProduct) {
                   discountTotal += curPrice - ((curPrice*this.shoppingCart[i].amount)/2);
                // discountTotal += (discountTotal/2)  ;
                //  this.discountName = "50% off";
              } 

            }
        }
        return discountTotal ;
    },
    
    
    extraDiscount() {

      var discountPercentage = 0;
      var theDiscount = {};
      theDiscount["amount"] = 0;
      // for(var i=0 ; i < this.discountsList.length ; i++) {
      var curTime = new Date().getTime();
      for (const [key, value] of Object.entries(this.discountsList)) {
        var cond = new Date(value["sdate"]).getTime() < curTime && new Date(value["edate"]).getTime() > curTime; 
        if(new Date(value["sdate"]).getTime() < curTime && new Date(value["edate"]).getTime() > curTime) {

          theDiscount["name"] = value["name"];
          theDiscount["description"] = value["description"];
          if(value["type"] == "percentage") {
            theDiscount["amount"] = ((this.cartTotal/100)*value["amount"])
          }
          if(value["type"] == "sum") {
            theDiscount["amount"] = value["amount"];
          }
        }
      }
      return theDiscount;
    },
    cartTotal() {
        var total = 0;
        var shoppingCart = this.$store.state.shoppingCart
        for(var i=0 ; i < shoppingCart.length ; i++) {
            var curPrice = this.custom_fixUglyPrice(shoppingCart[i].Price);
            var cp = curPrice.split(" ")[0];
            total += parseFloat(cp);
        }
        total -= this.discountTotal;           
        return total;
    },
    grandTotal() {
        var total = 0;
        // for(var i=0 ; i < this.shoppingCart.length ; i++) {
        //     var curPrice = this.custom_fixUglyPrice(this.shoppingCart[i].Price);
        //     var cp = curPrice.split(" ")[0];
        //     total += parseFloat(cp*this.shoppingCart[i].amount);
        // }

        total = this.cartTotal;
        total -= this.extraDiscount["amount"];
        if(this.chargeShipping) {

          total += this.shippingTotal;
        }
         
        return total;
    }
  },
})

// import iframeResize from './assets/iframe-resizer/js/iframeResizer';

// app.directive('resize', {
//   bind: function(el, { value = {} }) {
//     el.addEventListener('load', () => iframeResize(value, el))
//   },
//   unbind: function (el) {
//     el.iFrameResizer.removeListeners();
//   }
// })


app.use(store).use(router).mount('#app')
i18n.locale = 'nl'

export {router}
export {store}
export {createI18n}

